import React from 'react';

import styled from 'styled-components';

import BuilderCategoryNavBreadcrumbs from '~/grid/components/categoryNav/BuilderCategoryNavBreadcrumbs';
import useHasFeature, { featureNames } from '~/shared/utils/useHasFeature';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

import useGridInputs from '../hooks/useGridInputs';
import useProductGridData from '../hooks/useProductGridData';

import DesktopGridSortDropdown from './DesktopGridSortDropdown';
import DesktopSideNavBreadcrumbs from './DesktopSideNav/DesktopSideNavBreadcrumbs';

const HeaderWrapper = styled.div`
  position: relative;
  display: flex;
  padding: 20px 32px 0 32px;
  margin-top: 32px;
  margin-bottom: 24px;
  justify-content: space-between;
  align-items: center;
`;

// This wrapper is used to align the breadcrumbs and the title
const DesktopSideNavBreadCrumbsWrapper = styled.div`
  margin-right: 2rem;
  flex: 0 0 268px;
`;

const HeaderLabelsWrapper = styled.div`
  ${({ theme }) => theme.gridHeaderStyle};
`;

const HeaderTitle = styled.h1`
  font-weight: bold;
  font-size: 1.5rem;
  width: 100%;
`;

const SubheaderTitle = styled.h2`
  font-weight: 400;
  font-size: 1rem;
  padding-top: 8px;
`;

const DesktopGridHeader = () => {
  // search grid, ie from ConstructorSearchV1_1, do not set gridHeader/subheader,
  // and we do not want to add setting them there in case coupling useCioSearchAndGqlProducts
  // there leads to circular dependencies later down the line (at time of writing it does not)
  //
  // so instead, we set search headers here, if there are search results we use them instead of
  // the builderGridHeader in useGridInputs (ie for categories/collections from Builder pages)
  const { gridHeader: builderGridHeader } = useGridInputs();
  const { searchQuery, totalNumResults: count } = useProductGridData();

  const searchGridHeader = (
    <FormattedMessage
      id="search_results.results_heading_search"
      defaultMessage='Results for "{searchQuery}"'
      values={{ searchQuery }}
    />
  );
  const searchGridSubheader = (
    <FormattedMessage
      id="search_results.results_heading_total_count"
      defaultMessage="{count} results"
      values={{ count }}
    />
  );

  const gridHeader = searchQuery ? searchGridHeader : builderGridHeader;
  const gridSubheader = count ? searchGridSubheader : null;

  const { enabled: showBuilderSideNav } = useHasFeature(
    featureNames.BUILDER_CATEGORY_SIDE_NAV
  );

  return (
    <HeaderWrapper>
      <DesktopSideNavBreadCrumbsWrapper>
        {showBuilderSideNav ? (
          <BuilderCategoryNavBreadcrumbs />
        ) : (
          <DesktopSideNavBreadcrumbs />
        )}
      </DesktopSideNavBreadCrumbsWrapper>
      <HeaderLabelsWrapper>
        <HeaderTitle>{gridHeader}</HeaderTitle>
        {gridSubheader && <SubheaderTitle>{gridSubheader}</SubheaderTitle>}
      </HeaderLabelsWrapper>
      <DesktopGridSortDropdown />
    </HeaderWrapper>
  );
};

export default DesktopGridHeader;
